import React, { useCallback, useState } from "react";
import { Button } from "@mui/material";
import { PageHeader } from "shared/components/Headers/PageHeader";
import { PlusCircleIcon } from "shared/icons/PlusCircleIcon";
import { TagsTable } from "./TagsTable";

export const Tags = () => {
  const [isAddingTag, setIsAddingTag] = useState<boolean>(false);

  const handleOnCloseForm = useCallback(() => setIsAddingTag(false), []);

  return (
    <div className="layout-title-body-page">
      <PageHeader
        pageName="tags"
        title="Tags"
        actions={
          <Button onClick={() => setIsAddingTag(true)}>
            <PlusCircleIcon />
            Add tag
          </Button>
        }
      />

      <TagsTable isAddingTag={isAddingTag} onClose={handleOnCloseForm} />
    </div>
  );
};
